<template>
    <div class="content">
        <base-header class="pb-6">
            <div class="row align-items-center py-4">
                <div class="col-lg-6 col-7">
                    <h6 class="h2 text-white d-inline-block mb-0">
                        {{ $t("menu.member") }}
                    </h6>
                    <nav
                        aria-label="breadcrumb"
                        class="d-none d-md-inline-block ml-md-4"
                    >
                        <route-bread-crumb></route-bread-crumb>
                    </nav>
                </div>

                <div class="col-lg-6 col-5 text-right">
                    <base-button
                        size="md"
                        type="neutral"
                        @click="handleCreate()"
                        >{{ $t("new") }}</base-button
                    >
                </div>
            </div>
        </base-header>
        <div class="container-fluid mt--6">
            <div>
                <card
                    class="no-border-card"
                    body-classes="px-0 pb-1"
                    footer-classes="pb-2"
                >
                    <template slot="header">
						<div class="row">
                        <div class="col-lg-3">
                            <base-input
                                v-model="searchQuery"
                                prepend-icon="fas fa-search"
                                :placeholder="$t('search')"
                                @keyup.enter="handleSearch"
                            >
                            </base-input>
                        </div>

						<div class="col-md-2">
							<base-input>
								<el-select
									v-model="filterStatus"
									:placeholder="$t('status')"
									filterable
									@change="handleSearch"
								>
									<el-option
										v-for="option in StatusTableWithAll"
										:key="option.id"
										:label="option.name"
										:value="option.id"
									>
									</el-option>
								</el-select>
							</base-input>
						</div>

						<div class="col-md-2">
							<base-button
								type="primary"
								icon
								@click="handleSearch"
								:loading="searchLoading"
							>
								<i class="fas fa-search"></i>
								{{ $t('search') }}
							</base-button>
						</div>

						<div class="col-md-2">
							<base-button
								type="secondary"
								icon
								@click="handleClearSearch"
							>
								<i class="fas fa-times"></i>
								{{ $t('clear') }}
							</base-button>
						</div>

						</div>
                    </template>
                    <div>
                        <el-table
                            :data="queriedData"
                            row-key="id"
                            header-row-class-name="thead-light"
                        >
							<el-table-column :label="$t('name')">
								<div slot-scope="{ row }" class="d-flex" >
									{{ row.fname + " " + row.lname }}
								</div>
							</el-table-column>

							<el-table-column :label="$t('phone')">
								<div slot-scope="{ row }" class="d-flex" >
									{{ row.phone }}
								</div>
							</el-table-column>

							<el-table-column :label="$t('email')">
								<div slot-scope="{ row }" class="d-flex" >
									{{ row.email }}
								</div>
							</el-table-column>

							<el-table-column :label="$t('member.total_spending')">
								<div slot-scope="{ row }" class="d-flex" >
									{{ formatCurrency(row.total_spending) }}
								</div>
							</el-table-column>

							<el-table-column :label="$t('member.address')">
								<div slot-scope="{ row }" class="d-flex" >
									{{ row.address }}
								</div>
							</el-table-column>

							<el-table-column :label="$t('status')">
								<div slot-scope="{ row }" class="d-flex" >
									<badge
										:type="getStatusBadgeType(row.status)"
									>
										{{ getStatusName(row.status) }}
									</badge>
								</div>
							</el-table-column>

                            <el-table-column
                                min-width="200px"
                                align="right"
                                :label="$t('actions')"
                            >
                                <div
                                    slot-scope="{ $index, row }"
                                    class="d-flex"
                                >
                                    <base-button
                                        @click.native="handleEdit($index, row)"
                                        class="edit"
                                        type="warning"
                                        size="sm"
                                        icon
                                    >
                                        <i class="text-dtac-bt fa fa-edit"></i>
                                    </base-button>
									<base-button
                                        @click.native="handleViewCoupons($index, row)"
                                        class="edit"
                                        type="info"
                                        size="sm"
                                        icon
                                    >
                                        <i class="text-dtac-bt fa fa-ticket-alt"></i>
                                    </base-button>
                                    <base-button
                                        @click.native="
                                            handleDelete($index, row)
                                        "
                                        class="remove btn-link"
                                        type="danger"
                                        size="sm"
                                        icon
                                    >
                                        <i class="text-dtac-bt fa fa-trash"></i>
                                    </base-button>
                                </div>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div
                        slot="footer"
                        class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
                        v-if="tableData.length != 0"
                    >
                        <div class="">
                            <p class="card-category">
                                {{ $t("data") }} {{ from + 1 }} {{ $t("to") }}
                                {{ to }}
                                {{ $t("of") }}
                                {{ total }}
                                <span v-if="selectedRows.length">
                                    - &nbsp; &nbsp; {{ selectedRows.length }}
                                    {{ $t("row_select") }}
                                </span>
                            </p>
                        </div>
                        <base-pagination
                            class="pagination-no-border"
                            v-model="pagination.currentPage"
                            :per-page="pagination.perPage"
                            :total="total"
                        >
                        </base-pagination>
                    </div>
                </card>
            </div>
        </div>

        <modal :show.sync="showAddModal" modal-classes="modal-secondary">
			<validation-observer ref="formValidator" >
				<form class="new-event--form" @submit.prevent="saveEvent">
					<div class="row">
						<div class="col-md-6">
							<base-input :label="$t('fname')" :name="$t('fname')" v-model="params.fname" rules="required"> </base-input>
						</div>
						<div class="col-md-6">
							<base-input :label="$t('lname')" :name="$t('lname')" v-model="params.lname" rules="required"> </base-input>
						</div>
					</div>

					<div class="row">
						<div class="col-md-6">
							<base-input :label="$t('phone')" :name="$t('phone')" v-model="params.phone" rules="required"> </base-input>
						</div>
						<div class="col-md-6">
							<base-input :label="$t('email')" :name="$t('email')" v-model="params.email" rules="required|email"> </base-input>
						</div>
					</div>

					<div class="row">
						<div class="col-md-6">
							<base-input :label="$t('member.line_user_id')" :name="$t('member.line_user_id')" v-model="params.line_user_id" rules="required"> </base-input>
						</div>
						<div class="col-md-6">
							<base-input :label="$t('member.birthday')" :name="$t('member.birthday')" v-model="params.birthday" type="date"> </base-input>
						</div>
					</div>

					<div class="row">
						<div class="col-md-6">
							<base-input :label="$t('member.sex')" >
								<el-select v-model="params.sex" :placeholder="$t('member.sex')" filterable >
									<el-option
										v-for="option in SexTable"
										:key="option.id"
										:label="option.name"
										:value="option.id"
									>
									</el-option>
								</el-select>
							</base-input>
						</div>
						<div class="col-md-6">
							<base-input :label="$t('status')" >
								<el-select v-model="params.status" :placeholder="$t('status')" filterable >
									<el-option
										v-for="option in StatusTable"
										:key="option.id"
										:label="option.name"
										:value="option.id"
									>
									</el-option>
								</el-select>
							</base-input>
						</div>
					</div>

					<div class="row">
						<div class="col-md-12">
							<base-input :label="$t('member.address')" :name="$t('member.address')" v-model="params.address" rules="required"> </base-input>
						</div>
					</div>

					<div class="row">
						<div class="col-md-4">
							<base-input :label="$t('member.province')" :name="$t('member.province')" v-model="params.province" rules="required"> </base-input>
						</div>
						<div class="col-md-4">
							<base-input :label="$t('member.district')" :name="$t('member.district')" v-model="params.district" rules="required"> </base-input>
						</div>
						<div class="col-md-4">
							<base-input :label="$t('member.subdistrict')" :name="$t('member.subdistrict')" v-model="params.subdistrict" rules="required"> </base-input>
						</div>
					</div>

					<div class="row">
						<div class="col-md-6">
							<base-input :label="$t('member.postcode')" :name="$t('member.postcode')" v-model="params.postcode"> </base-input>
						</div>
						<div class="col-md-6" v-if="id == 0">
							<base-input :label="$t('password')" :name="$t('password')" v-model="params.password" type="password" rules="required|min:6"> </base-input>
						</div>
					</div>

				</form>
			</validation-observer>

            <template slot="footer">
                <button
                    type="submit"
                    class="btn btn-md btn-primary"
                    @click="handleUpdate()"
                >
                    {{ $t("save") }}
                </button>
                <button
                    type="button"
                    class="btn btn-md btn-link ml-auto"
                    @click="showAddModal = false"
                >
                    {{ $t("close") }}
                </button>
            </template>
        </modal>

		<!-- Member Coupons Modal -->
		<modal :show.sync="showCouponsModal" modal-classes="modal-lg">
			<template slot="header">
				<h3 class="modal-title">{{ $t('member.coupons') }} - {{ currentMemberName }}</h3>
			</template>
			
			<div v-if="memberCoupons.length > 0">
				<el-table :data="memberCoupons" header-row-class-name="thead-light">
					<el-table-column :label="$t('member.coupon_code')" prop="code"></el-table-column>
					<el-table-column :label="$t('member.coupon_status')">
						<div slot-scope="{ row }">
							<badge :type="row.is_used ? 'success' : 'info'">
								{{ row.is_used ? $t('member.used') : $t('member.unused') }}
							</badge>
						</div>
					</el-table-column>
					<el-table-column :label="$t('member.created_at')">
						<div slot-scope="{ row }">
							{{ formatDate(row.coupon_created_at) }}
						</div>
					</el-table-column>
					<el-table-column :label="$t('member.used_at')">
						<div slot-scope="{ row }">
							{{ row.coupon_used_at ? formatDate(row.coupon_used_at) : '-' }}
						</div>
					</el-table-column>
				</el-table>
			</div>
			<div v-else class="text-center py-4">
				<p>{{ $t('member.no_coupons') }}</p>
			</div>

			<template slot="footer">
				<button
					type="button"
					class="btn btn-md btn-link ml-auto"
					@click="showCouponsModal = false"
				>
					{{ $t("close") }}
				</button>
			</template>
		</modal>

    </div>
</template>
<script>
import { Table, TableColumn, Select, Option } from "element-ui";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import { BasePagination } from "@/components";
import clientPaginationMixin from "../PaginatedTables/clientPaginationMixin";
import swal from "sweetalert2";
import { mapGetters, mapActions } from "vuex";

export default {
    mixins: [clientPaginationMixin],
    components: {
        BasePagination,
        RouteBreadCrumb,
        [Select.name]: Select,
        [Option.name]: Option,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
    },
    computed: {
        ...mapGetters({
            tableDataOrg: "Member/getData",
            StatusTable: "Member/getStatusTable",
            StatusTableWithAll: "Member/getStatusTableWithAll",
            SexTable: "Member/getSexTable",
            memberCoupons: "Member/getMemberCoupons",
        }),
		tableData: function() {
			let data = this.tableDataOrg
			if(this.filterStatus != -1){
				data = data.filter(x => x.status == this.filterStatus)
			}
			return data
		}
    },
    data() {
        return {
            propsToSearch: ["fname", "lname", "phone", "email"],
            selectedRows: [],
            showAddModal: false,
			showCouponsModal: false,
			filterStatus: -1,
			searchLoading: false,
			id: 0,
			currentMemberName: '',
			params:{
				enterprise_id: 1,
				fname: "",
				lname: "",
				line_user_id: "",
				phone: "",
				email: "",
				birthday: "1990-01-01",
				sex: 0,
				status: 0,
				password: "",
				address: "",
				province: "",
				district: "",
				subdistrict: "",
				postcode: "00000",
				province_id: 0,
				district_id: 0,
				subdistrict_id: 0,
			},
        };
    },
    mounted() {
        this.listData();
    },
    methods: {
        ...mapActions({
            createData: "Member/createData",
            updateData: "Member/updateData",
            deleteData: "Member/deleteData",
            listData: "Member/listData",
            getMemberCoupons: "Member/getMemberCoupons",
        }),
        handleCreate() {
            this.showAddModal = true;
			this.id = 0;
			this.resetParams();
        },
        handleEdit(index, row) {
            this.showAddModal = true;
            this.id = row.id;
            this.params.fname = row.fname;
            this.params.lname = row.lname;
            this.params.line_user_id = row.line_user_id;
            this.params.phone = row.phone;
            this.params.email = row.email;
            this.params.birthday = row.birthday ? row.birthday.split('T')[0] : '1990-01-01';
            this.params.sex = row.sex;
            this.params.status = row.status;
            this.params.address = row.address;
            this.params.province = row.province;
            this.params.district = row.district;
            this.params.subdistrict = row.subdistrict;
            this.params.postcode = row.postcode;
            this.params.province_id = row.province_id;
            this.params.district_id = row.district_id;
            this.params.subdistrict_id = row.subdistrict_id;
        },
        async handleUpdate() {
			let valid = await this.$refs.formValidator.validate()
			if (!valid) return

            this.showAddModal = false;

            if (this.id == 0) {
                this.createData(this.params)
                    .then(resp => {
                        this.listData();
                        swal.fire({
                            title: this.$t("create_success"),
                            text: ``,
                            icon: "success",
                            confirmButtonClass: "btn btn-success btn-fill",
                            buttonsStyling: false
                        });
                    })
                    .catch(err => {
                        swal.fire({
                            title: err.response.data.Cause || this.$t("error"),
                            text: "",
                            icon: "error",
                            confirmButtonClass: "btn btn-danger btn-fill",
                            buttonsStyling: false
                        });
                    });
            } else {
				let payload = {
					id: this.id,
					payload: this.params
				}
                this.updateData(payload)
                    .then(resp => {
                        this.listData();
                        swal.fire({
                            title: this.$t("edit_success"),
                            text: ``,
                            icon: "success",
                            confirmButtonClass: "btn btn-success btn-fill",
                            buttonsStyling: false
                        });
                    })
                    .catch(err => {
                        swal.fire({
                            title: err.response.data.Cause || this.$t("error"),
                            text: "",
                            icon: "error",
                            confirmButtonClass: "btn btn-danger btn-fill",
                            buttonsStyling: false
                        });
                    });
            }
        },
        handleDelete(index, row) {
            swal.fire({
                title: this.$t("delete_confirm"),
                text: this.$t("delete_confirm_question") + row.fname + " " + row.lname + " ?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonClass: "btn btn-success btn-fill",
                cancelButtonClass: "btn btn-danger btn-fill",
                confirmButtonText: this.$t("confirm"),
                cancelButtonText: this.$t("cancel"),
                buttonsStyling: false
            }).then(result => {
                if (result.value) {
                    this.deleteData(row.id)
                        .then(resp => {
                            this.listData();
                            swal.fire({
                                title: this.$t("delete_success"),
                                text: ``,
                                icon: "success",
                                confirmButtonClass: "btn btn-success btn-fill",
                                buttonsStyling: false
                            });
                        })
                        .catch(err => {
                            swal.fire({
                                title: err.response.data.Cause || this.$t("error"),
                                text: "",
                                icon: "error",
                                confirmButtonClass: "btn btn-danger btn-fill",
                                buttonsStyling: false
                            });
                        });
                }
            });
        },
		async handleViewCoupons(index, row) {
			this.currentMemberName = row.fname + " " + row.lname;
			this.showCouponsModal = true;
			
			try {
				await this.getMemberCoupons({
					id: row.id,
					params: { page: 1, limit: 100 }
				});
			} catch (error) {
				swal.fire({
					title: this.$t("error"),
					text: this.$t("member.error_loading_coupons"),
					icon: "error",
					confirmButtonClass: "btn btn-danger btn-fill",
					buttonsStyling: false
				});
			}
		},
		resetParams() {
			this.params = {
				enterprise_id: 1,
				fname: "",
				lname: "",
				line_user_id: "",
				phone: "",
				email: "",
				birthday: "1990-01-01",
				sex: 0,
				status: 0,
				password: "",
				address: "",
				province: "",
				district: "",
				subdistrict: "",
				postcode: "00000",
				province_id: 0,
				district_id: 0,
				subdistrict_id: 0,
			};
		},
		getStatusName(status) {
			const statusObj = this.StatusTable.find(s => s.id === status);
			return statusObj ? statusObj.name : '';
		},
		getStatusBadgeType(status) {
			switch(status) {
				case 0: return 'warning'; // Non-verified
				case 1: return 'success'; // Normal
				case 2: return 'danger';  // Blocked
				default: return 'secondary';
			}
		},
		formatCurrency(amount) {
			return new Intl.NumberFormat('th-TH', {
				style: 'currency',
				currency: 'THB'
			}).format(amount || 0);
		},
		formatDate(dateString) {
			if (!dateString) return '';
			return new Date(dateString).toLocaleDateString('th-TH');
		},
		async handleSearch() {
			this.searchLoading = true;
			try {
				const params = {
					search: this.searchQuery,
					status: this.filterStatus !== -1 ? this.filterStatus : undefined,
					page: 1,
					limit: 20
				};
				await this.listData(params);
			} catch (error) {
				console.error('Search error:', error);
			} finally {
				this.searchLoading = false;
			}
		},
		handleClearSearch() {
			this.searchQuery = '';
			this.filterStatus = -1;
			this.listData();
		}
    }
};
</script>
<style>
.no-border-card .card-footer {
    border-top: 0;
}
</style>